
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import GlobalImageLightbox from './components/base/GlobalImageLightbox'
import AdminEducationCleanup from './components/feature/AdminEducationCleanup'
import FooterSettingsPanel from './components/feature/FooterSettingsPanel'
import SiteFooter from './components/feature/SiteFooter'

function App() {
  const basePath = import.meta.env.VITE_BASE_PATH || '/';
  return (
    <BrowserRouter basename={basePath}>
      <AppRoutes />
      <AdminEducationCleanup />
      <FooterSettingsPanel />
      <SiteFooter />
      <GlobalImageLightbox />
    </BrowserRouter>
  )
}

export default App
